"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.VehicleList = void 0;
const complex_data_1 = require("complex-data");
const vehicle_1 = __importDefault(require("@/pages/index/api/vehicle"));
const config_1 = require("@/config/dictionary/config");
const layout_1 = __importDefault(require("@/config/utils/layout"));
const dictionary_1 = require("@/config/dictionary");
const overdue_1 = require("@/pages/index/select/overdue");
const dict_1 = require("@/pages/index/select/dict");
const select_1 = require("@/pages/index/select");
class VehicleList extends complex_data_1.ComplexList {
}
exports.VehicleList = VehicleList;
const layoutParse = new layout_1.default(2, 6, 16);
const vehicleList = new VehicleList({
    name: '车辆明细',
    prop: 'vehicleList',
    module: {
        pagination: true,
        search: {
            module: {
                dictionary: {
                    layout: {
                        default: {
                            grid: 8,
                            label: 8,
                            content: 16
                        }
                    },
                    list: [
                        (0, dictionary_1.buildDictionaryBySelect)(dict_1.dict.business_lines_green, {
                            prop: 'itemname',
                            name: '业务线',
                            originProp: 'itemname',
                            originFrom: 'local',
                            mod: {
                                search: {
                                    $target: 'edit'
                                }
                            }
                        }, {
                            onlyLabel: true
                        }),
                        {
                            prop: 'customerName',
                            name: '承租人',
                            originProp: 'customerName',
                            originFrom: 'local',
                            mod: {
                                search: {
                                    $type: 'edit',
                                    type: 'input',
                                    option: {
                                        maxLength: 100
                                    }
                                }
                            }
                        },
                        {
                            prop: 'applyUserName',
                            name: '保全人员',
                            originProp: 'applyUserName',
                            originFrom: 'local',
                            mod: {
                                search: {
                                    $type: 'edit',
                                    type: 'input',
                                    option: {
                                        maxLength: 100
                                    }
                                }
                            }
                        },
                        {
                            prop: 'contractNumber',
                            name: '合同号',
                            originProp: 'contractNumber',
                            originFrom: 'local',
                            mod: {
                                search: {
                                    $type: 'edit',
                                    type: 'input',
                                    option: {
                                        maxLength: 100
                                    }
                                }
                            }
                        },
                        {
                            prop: 'vinNo',
                            name: '车架号',
                            originProp: 'vinNo',
                            originFrom: 'local',
                            mod: {
                                search: {
                                    $type: 'edit',
                                    type: 'input'
                                }
                            }
                        },
                        // {
                        //   prop: 'beginUpdatedTime',
                        //   name: '创建时间',
                        //   originProp: 'beginUpdatedTime',
                        //   originFrom: 'local',
                        //   post(value, { targetData }) {
                        //     if (value) {
                        //       targetData.endUpdatedTime = (value as string[])[1]
                        //       return (value as string[])[0]
                        //     }
                        //   },
                        //   mod: {
                        //     search: {
                        //       $type: 'edit',
                        //       type: 'dateRange',
                        //       option: {
                        //         time: {}
                        //       }
                        //     }
                        //   }
                        // },
                    ]
                }
            },
            menu: {
                list: []
            },
        },
        dictionary: {
            layout: {
                default: layoutParse.getData(2)
            },
            option: {},
            propData: {
                id: 'id'
            },
            list: [
                {
                    prop: 'id',
                    name: '逾期记录ID',
                    originProp: 'id',
                    originFrom: 'list',
                    mod: {}
                },
                {
                    prop: 'contractId',
                    name: '合同ID',
                    originProp: 'contractId',
                    originFrom: 'list',
                    mod: {}
                },
                {
                    prop: 'contractNumber',
                    name: '合同号',
                    originProp: 'contractNumber',
                    originFrom: 'list',
                    mod: {
                        list: {
                            width: config_1.listWidth.contractNumber
                        }
                    }
                },
                {
                    prop: 'itemname',
                    name: '业务线',
                    originProp: 'itemname',
                    originFrom: 'list',
                    mod: {
                        list: {
                            width: config_1.listWidth.businessLine
                        }
                    }
                },
                {
                    prop: 'customerName',
                    name: '承租人',
                    originProp: 'customerName',
                    originFrom: 'list',
                    mod: {
                        list: {
                            width: config_1.listWidth.personnelName
                        }
                    }
                },
                {
                    prop: 'brandname',
                    name: '车辆品牌',
                    originProp: 'brandname',
                    originFrom: 'list',
                    mod: {
                        list: {}
                    }
                },
                {
                    prop: 'modelname',
                    name: '车辆型号',
                    originProp: 'modelname',
                    originFrom: 'list',
                    mod: {
                        list: {}
                    }
                },
                {
                    prop: 'vinNo',
                    name: '车架号',
                    originProp: 'vinNo',
                    originFrom: 'list',
                    mod: {
                        list: {
                            width: config_1.listWidth.vin
                        }
                    }
                },
                {
                    prop: 'engineNumber',
                    name: '发动机型号',
                    originProp: 'engineNumber',
                    originFrom: 'list',
                    mod: {
                        list: {
                            width: config_1.listWidth.vehicleEngineModel
                        }
                    }
                },
                {
                    prop: 'engineNo',
                    name: '发动机编号',
                    originProp: 'engineNo',
                    originFrom: 'list',
                    mod: {
                        list: {
                            width: config_1.listWidth.vehicleEngineNo
                        }
                    }
                },
                {
                    prop: 'licensePlateNumber',
                    name: '车牌号',
                    originProp: 'licensePlateNumber',
                    originFrom: 'list',
                    mod: {
                        list: {}
                    }
                },
                {
                    prop: 'carColour',
                    name: '颜色',
                    originProp: 'carColour',
                    originFrom: 'list',
                    mod: {
                        list: {}
                    }
                },
                {
                    prop: 'storageTime',
                    name: '入库时间',
                    originProp: 'storageTime',
                    originFrom: 'list',
                    mod: {
                        list: {
                            width: config_1.listWidth.time
                        }
                    }
                },
                (0, dictionary_1.buildDictionaryBySelect)(overdue_1.vehicleStatus, {
                    prop: 'vehicleStatus',
                    name: '车辆状态',
                    originProp: 'vehicleStatus',
                    originFrom: 'list',
                    mod: {
                        list: {}
                    }
                }),
                (0, dictionary_1.buildDictionaryBySelect)(overdue_1.overdueStatus, {
                    prop: 'overStatus',
                    name: '逾期状态',
                    originProp: 'overStatus',
                    originFrom: 'list',
                    mod: {}
                }),
                {
                    prop: 'applyUserName',
                    name: '保全人员',
                    originProp: 'applyUserName',
                    originFrom: 'list',
                    mod: {
                        list: {
                            width: config_1.listWidth.personnelName
                        }
                    }
                },
                {
                    prop: 'parkPointName',
                    name: '停车场',
                    originProp: 'parkPointName',
                    originFrom: 'list',
                    mod: {
                        list: {
                            width: config_1.listWidth.getWidth(10)
                        }
                    }
                },
                (0, dictionary_1.buildDictionaryBySelect)(select_1.baseSwitch, {
                    prop: 'keepInStorageFlag',
                    name: '是否保全入库',
                    originProp: 'keepInStorageFlag',
                    originFrom: 'list',
                    mod: {
                        list: {}
                    }
                }),
                {
                    prop: 'warehousingDate',
                    name: '停车时间',
                    originProp: 'warehousingDate',
                    originFrom: 'list',
                    mod: {
                        list: {
                            width: config_1.listWidth.time
                        }
                    }
                },
                {
                    prop: 'updatedTime',
                    name: '更新时间',
                    originProp: 'updatedTime',
                    originFrom: 'list',
                    mod: {}
                },
            ]
        }
    },
    $getData() {
        return new Promise((resolve, reject) => {
            vehicle_1.default.vehicleList.require(Object.assign(Object.assign({}, this.$getSearch()), { pageNo: this.$getPageData('current'), pageSize: this.$getPageData('size') })).then(res => {
                this.$formatList(res.data.data, res.data.totalCount);
                resolve({ status: 'success' });
            }).catch(err => {
                // eslint-disable-next-line no-console
                console.error(err);
                reject(err);
            });
        });
    }
});
exports.default = vehicleList;
